import React, { FunctionComponent, useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Grid, Box } from "@material-ui/core";
import { useRoleStyles } from "./useRoleStyles";
import { AddRoles } from "./RolePermissions/AddRoles";
import { RolePermissions } from "./RolePermissions/RolePermissions";
import { api } from "../../api";
import { useStore } from "../../store";
import { RolesTableList } from "./RolePermissions/RolesList/RolesTableList";
import { Helmet } from "react-helmet-async";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};

export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export const Roles = () => {
  const classes = useRoleStyles();
  const [roles] = useStore("roles");
  const [user] = useStore("auth", "user");
  const [value, setValue] = React.useState(0);
  const [permissionDetails, setPermissionDetails] = useState<any>();
  const [expandedData, setExpandedData] = useState<any>();
  const [roleData, setRoleData] = useState<any>(undefined);
  const [permissionFlag, setPermissionFlag] = useState<boolean>(true);
  const [viewRolePermission, setViewRolePermission] = useState<boolean>(false);
  const [editRolePermission, setEditRolePermission] = useState<boolean>(false);
  const [addRolePermission, setAddRolePermission] = useState<boolean>(false);

  const userPriorities =
    roles &&
    roles
      .filter((i: any) => user.roles.some((j: any) => j == i.id))
      .map((i: any) => i.priority_level);

  const maxPriority = Math.min(...userPriorities);

  const filteredRolesByPriority =
    user.is_super_admin === true
      ? roles
      : roles && roles.filter((i: any) => i.priority_level > maxPriority);

  useEffect(() => {
    const rolePermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 4
    );

    if (user.is_super_admin === true) {
      setAddRolePermission(true);
      setViewRolePermission(true);
      setEditRolePermission(true);
    } else {
      if (rolePermission) {
        if (rolePermission.is_add === true) {
          setAddRolePermission(true);
        }
        if (rolePermission.is_view === true) {
          setViewRolePermission(true);
        }
        if (rolePermission.is_edit === true) {
          setEditRolePermission(true);
        }
      }
    }
  });

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setPermissionFlag(true);
    setRoleData(undefined);
    getDetails();
  };
  const goBackToList = () => {
    setValue(0);
    setRoleData(undefined);
    setPermissionFlag(false);
  };

  const handlePermissionFlag = () => {
    setPermissionFlag(false);
  };
  const changeToRoles = () => {
    setValue(1);
  };

  const setEditRow = (data: any) => {
    setRoleData(data);
    setValue(1);
  };

  const getDetails = async () => {
    try {
      const roleid = roles && roles[0].id;
      const result = await api.get(`roles/${roleid}/permissions`);
      const expandedArray: any = [];
      const arr: any = [];
      result &&
        result.map((i: any) =>
          i.is_add === true ? arr.push(i.permission_id + ":is_add") : null
        );
      result &&
        result.map((i: any) =>
          i.is_edit === true ? arr.push(i.permission_id + ":is_edit") : null
        );
      result &&
        result.map((i: any) =>
          i.is_view === true ? arr.push(i.permission_id + ":is_view") : null
        );
      result &&
        result.map((i: any) =>
          i.is_delete === true ? arr.push(i.permission_id + ":is_delete") : null
        );
      result && result.map((i: any) => expandedArray.push(i.permission_id));
      setPermissionDetails(arr);
      setExpandedData(expandedArray);
    } catch (error) {
      console.log(error);
      setPermissionDetails(undefined);
      setExpandedData(undefined);
    }
  };

  return (
    <>
      <Helmet>
        <title>Roles</title>
      </Helmet>
      <div className={classes.root}>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab
              label="Roles List"
              style={{ display: viewRolePermission ? "" : "none" }}
            />
            <Tab
              label={roleData === undefined ? "Create Role" : "Edit Role"}
              style={{ display: addRolePermission ? "" : "none" }}
            />
            <Tab
              label="Permissions"
              style={{ display: editRolePermission ? "" : "none" }}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <Grid
            container
            spacing={2}
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item xs={12}>
              <RolesTableList
                roleslist={roles}
                setEditRow={setEditRow}
                editRolePermission={editRolePermission}
                maxPriority={maxPriority}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AddRoles roleData={roleData} goBackToList={goBackToList} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <RolePermissions
            role_id={roles && roles[0].id}
            permissionDetails={permissionDetails}
            expandedData={expandedData}
            changeToRoles={changeToRoles}
            goBackToList={goBackToList}
            permissionFlag={permissionFlag}
            handlePermissionFlag={handlePermissionFlag}
            roles={filteredRolesByPriority}
            addRolePermission={addRolePermission}
          />
        </TabPanel>
      </div>
    </>
  );
};
